<template>
  <div class="submit-form">
    <div v-if="!submitted">
      <div class="form-group">
        <label for="name">Navn</label>
        <input
          type="text"
          class="form-control"
          id="name"
          required
          v-model="competition.name"
          name="name"
        />
      </div>

      <div class="form-group">
        <label for="functions">Ønskede funksjoner:</label>
        <div>
          <input type="checkbox" id="liveres" name="function" value="liveres" v-model="competition.functions" checked>
          <label for="liveres">Frisys - Liveres</label>
        </div>
        <div>
          <input type="checkbox" id="opprop" name="function" value="opprop" v-model="competition.functions" checked>
          <label for="opprop">Frisys - Opprop</label>
        </div>
      </div>
      <div class="form-group">
        <label for="date_start">Dato start (ÅÅÅÅ-MM-DD)</label>
        <input
          class="form-control"
          id="date_start"
          required
          v-model="competition.date_start"
          name="date_start"
        />
      </div>

      <div class="form-group">
        <label for="date_end">Dato slutt (ÅÅÅÅ-MM-DD)</label>
        <input
          class="form-control"
          id="date_end"
          required
          v-model="competition.date_end"
          name="date_end"
        />
      </div>

      <div class="form-group" style="display: none;">
        <label for="level">Nivå</label>
        <input
          class="form-control"
          id="level"
          v-model="competition.level"
          name="level"
        />
      </div>

      <div class="form-group">
        <label for="organizer">Arrangør</label>
        <input
          class="form-control"
          id="organizer"
          required
          v-model="competition.organizer"
          name="organizer"
        />
      </div>

      <div class="form-group">
        <label for="external_webpage">Webside</label>
        <input
          class="form-control"
          id="external_webpage"
          required
          v-model="competition.external_webpage"
          name="external_webpage"
        />
      </div>

      <div class="form-group" style="display: none;">
        <label for="venue_id">Stadion id (tall)</label>
        <input
          class="form-control"
          id="venue_id"
          v-model="competition.venue_id"
          name="venue_id"
        />
      </div>

      <div class="form-group" v-if="competition.functions.includes('liveres')">
        <label for="publishDate">Publiseringsdato (LiveRes) (ÅÅÅÅ-MM-DD)</label>
        <input type="text" class="form-control" id="publishDate" required
          v-model="competition.publishDate"
          name="publishDate"
        />
      </div>

      <div class="form-group" v-if="competition.functions.includes('liveres')">
        <label for="hideMissingCallroomAfterFirstResult">Skjul manglende opprop etter første resultat (LiveRes)</label>
        <input type="checkbox" id="hideMissingCallroomAfterFirstResult" 
          v-model="competition.hideMissingCallroomAfterFirstResult"
          name="hideMissingCallroomAfterFirstResult"
        />
      </div>

      <div class="form-group" v-if="competition.functions.includes('opprop')">
        <label for="email_body">Epost hovedtekst</label>
        <textarea v-model="competition.email_body" cols="110" rows="10">
        </textarea>
      </div>

      <!-- <div class="form-group">
        <label for="affiliation_team">Tilhørighet 'team'</label>
        <input
          class="form-control"
          id="affiliation_team"
          required
          v-model="competition.affiliation.team"
          name="affiliation_team"
        />
      </div>
      <div class="form-group">
        <label for="affiliation_field">Tilhørighet 'field'</label>
        <input
          class="form-control"
          id="affiliation_field"
          required
          v-model="competition.affiliation.field"
          name="affiliation_field"
        />
      </div> -->

      <button @click="saveCompetition" class="btn btn-success">Submit</button>
    </div>

    <div v-else>
      <h4>Stevne sendt inn!</h4>
      
      <!-- <button @click="updateAuthorizationInfo" class="btn btn-success">HABLE</button> -->
      <!-- <router-link to="/api/auth/vipps/updateAuthorizationInfo">HABLE</router-link> -->
      <!-- <button class="btn btn-success" @click="newCompetition">Add</button> -->
    </div>
  </div>
</template>

<script>
import CompetitionDataService from "../services/CompetitionDataService";
import VippsService from "../services/vipps.service";
import emailBodyText from "../config/default.config";

export default {
  name: "add-competition",
  data() {
    return {
      competition: {
        id: null,
        name: "",
        date_start: "",
        date_end: "",
        functions: [
          'liveres', 'opprop'
        ],
        level: 'standard',
        organizer: "",
        external_webpage: "",
        venue_id: 1,
        affiliation: {
          team: "",
          field: ""
        },
        publishDate: "",
        email_body: emailBodyText.email_body
      },
      submitted: false
    };
  },
  methods: {
    saveCompetition() {
      var data = {
        name: this.competition.name,
        date_start: this.competition.date_start,
        date_end: this.competition.date_end,
        functions: this.competition.functions,
        level: this.competition.level,
        organizer: this.competition.organizer,
        external_webpage: this.competition.external_webpage,
        venue_id: this.competition.venue_id,
        affiliation: {
          team: this.competition.affiliation.team,
          field: this.competition.affiliation.field
        },
        publishDate: this.competition.publishDate,
        hideMissingCallroomAfterFirstResult: this.competition.hideMissingCallroomAfterFirstResult,
        email_body: this.competition.email_body
      };

      CompetitionDataService.create(data)
        .then(response => {
          this.competition.id = response.data.id;
          console.log(response.data);
          this.submitted = true;
          this.updateAuthorizationInfo();
          this.$store.dispatch('competition/updateActiveCompetitions');
        })
        .catch(e => {
          console.log(e);
        });
    },
    newCompetition() {
      this.submitted = false;
      this.competition = {};
    },
    updateAuthorizationInfo() {
      VippsService.updateAuthorizationInfo();
      this.$store.dispatch('auth/vippsupdateauthorizationinfo').then(
        () => {
          console.log("Updating authorizationInfo");
          // this.$router.push('/vippsloggedin');
        },
        error => {
          this.loading = false;
          this.message =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      );
    }
  },
  mounted() {
    console.log("AddCompetition - mounted")
    
    const currentDate = new Date();
    this.competition.publishDate = currentDate.toISOString().split('T')[0];
    console.log(this.competition.publishDate); // 2021-09-01
  }
};
</script>

<style>
.submit-form {
  max-width: 300px;
  margin: auto;
}
</style>
